var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-list__checkbox"},[_c('checkbox',{attrs:{"value":_vm.checkboxValue,"size":_vm.checkboxSize}}),_c('div',{staticClass:"data-list__checkbox--text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }